import React, { useEffect, useState } from "react";
import api from "../api";

export default function Audit() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    let mounted = true;
    const tick = async () => {
      const { data } = await api.get("/admin/audit-log");
      if (mounted) setRows(data);
    };
    tick();
    const id = setInterval(tick, 15_000);
    return () => {
      mounted = false;
      clearInterval(id);
    };
  }, []);

  return (
    <div className="space-y-6" data-testid="audit-page">
      <div className="flex items-baseline justify-between">
        <h1 className="font-display text-3xl tracking-tight">Audit log</h1>
        <div className="text-xs font-mono text-muted-foreground">
          {rows.length} entries
        </div>
      </div>

      <div className="border border-border bg-black/40">
        {rows.length === 0 && (
          <div className="px-4 py-12 text-center text-sm font-mono text-muted-foreground">
            // no admin actions yet
          </div>
        )}
        {rows.map((r) => (
          <div
            key={r.id}
            className="px-4 py-2 border-b border-border last:border-b-0 font-mono text-xs grid grid-cols-[180px_180px_1fr] gap-4"
            data-testid={`audit-row-${r.id}`}
          >
            <span className="text-muted-foreground">
              {new Date(r.created_at).toISOString().replace("T", " ").slice(0, 19)}
            </span>
            <span className="text-foreground">{r.actor_email}</span>
            <span>
              <span className="text-emerald-400">{r.action}</span>
              <span className="text-muted-foreground">
                {" "}
                · {r.entity_type}/{r.entity_id?.slice(0, 8)}
              </span>
              {r.after && (
                <span className="text-muted-foreground">
                  {" → "}
                  {JSON.stringify(r.after)}
                </span>
              )}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
